var map = {
	"./BAT-logo.png": 534,
	"./BLUE-logo.png": 236,
	"./BUSD-logo.png": 535,
	"./COMP-logo.png": 536,
	"./CRV-logo.png": 537,
	"./DAI-logo.png": 538,
	"./ETH-logo.png": 539,
	"./FTM-logo.png": 540,
	"./KNC-logo.png": 541,
	"./LEND-logo.png": 542,
	"./LINK-logo.png": 543,
	"./MANA-logo.png": 544,
	"./MKR-logo.png": 545,
	"./REP-logo.png": 546,
	"./SAI-logo.png": 547,
	"./SNX-logo.png": 548,
	"./SUSD-logo.png": 549,
	"./TUSD-logo.png": 334,
	"./USD-logo.png": 550,
	"./USDC-logo.png": 551,
	"./USDT-logo.png": 552,
	"./WETH-logo.png": 553,
	"./YFI-logo.png": 554,
	"./ZRX-logo.png": 555,
	"./aLINK-logo.png": 556,
	"./cUSDC-logo.png": 557,
	"./cUSDT-logo.png": 558,
	"./crvBTC-logo.png": 559,
	"./crvBUSD-logo.png": 560,
	"./iDAI-logo.png": 561,
	"./wBTC-logo.png": 562,
	"./yCRV-logo.png": 563,
	"./ycUSDC-logo.png": 564,
	"./ycUSDT-logo.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;